import { useState } from 'react'
import AspectRatio from '@mui/joy/AspectRatio'
import Card from '@mui/joy/Card'
import CardContent from '@mui/joy/CardContent'
import Typography from '@mui/joy/Typography'
import Box from '@mui/joy/Box'
import Chip from '@mui/joy/Chip'
import { EditButton } from './ui/EditButton'
import { networkFromCanonical } from '../consts'
import { formatToLongDatetime } from '../utils'
import { MediaContainer } from './MediaContainer'
import { DownloadButton } from './ui/DownloadButton'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'

const ScheduleStatusChip = ({ schedule_date }) => {
    let color = 'danger'
    let msg = 'Needs Scheduling'
    if (schedule_date) {
        color = 'success'
        msg = 'Scheduled'
    }
    return (
        <Chip variant="soft" color={color}>
            {msg}
        </Chip>
    )
}

export const CampaignAssetItem = ({ asset, onSelect }) => {
    const [hovering, setHovering] = useState(false)
    const [isDownloading, setIsDownloading] = useState(false)

    const handleDownload = async (fileUrl) => {
        setIsDownloading(true)
        let reqUrl = `${fileUrl}?cache_key=${uuidv4()}`
        try {
            const response = await axios.get(reqUrl, {
                responseType: 'blob',
                withCredentials: false,
            })

            if (!response.status == 200) {
                throw new Error('Network response was not ok')
            }

            const url = window.URL.createObjectURL(response.data)

            const link = document.createElement('a')
            link.href = url
            link.download = fileUrl.split('/').at(-1)
            document.body.appendChild(link)
            link.click()
            link.remove()

            // Clean up the URL object
            window.URL.revokeObjectURL(url)
        } catch (error) {
            console.error('Download failed:', error)
        } finally {
            setIsDownloading(false)
        }
    }

    return (
        <Card
            sx={{ width: 320 }}
            variant={hovering ? 'soft' : 'outlined'}
            onMouseEnter={() => setHovering(true)}
            onMouseLeave={() => setHovering(false)}
        >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ScheduleStatusChip schedule_date={asset.schedule_date} />
            </Box>
            <MediaContainer url={asset.source_url} />
            <CardContent orientation="horizontal">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        gap: 2,
                    }}
                >
                    <Box>
                        <Box sx={{ display: 'flex', flex: 1, gap: 1 }}>
                            <Typography level="title-sm">
                                <b>Publish To:</b>
                            </Typography>
                            {asset.publish_to &&
                                asset.publish_to.map((network) => (
                                    <div key={network.display_name}>
                                        <Typography level="body-sm">
                                            {network.display_name}
                                        </Typography>
                                    </div>
                                ))}
                        </Box>
                        <Box sx={{ display: 'flex', flex: 1, gap: 1 }}>
                            <Typography level="title-sm">
                                <b>Scheduled For:</b>
                            </Typography>
                            {asset.schedule_date && (
                                <Typography level="body-sm">
                                    {formatToLongDatetime(asset.schedule_date)}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flex: 1,
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: 2,
                        }}
                    >
                        <DownloadButton
                            onClick={() => handleDownload(asset.source_url)}
                            disabled={isDownloading}
                        />
                        <EditButton onClick={() => onSelect(asset)} />
                    </Box>
                </Box>
            </CardContent>
        </Card>
    )
}
